// we need to export using commonjs for ease of usage in all
// JavaScript environments

/* eslint-disable import/no-commonjs */

import main from './src/lib/main.js';

module.exports = main;



/** WEBPACK FOOTER **
 ** ./index.js
 **/